/** Shared sticker geometry; Flutter mirrors these numbers. */
export const ROT = { min: -30, max: 30, step: 5 };
export const SCALE = { min: 0.6, max: 1.6, step: 0.1 };
/** A sticker at scale 1 is this fraction of the shorter side of its box. */
export const STICKER_BASE_FRACTION = 0.18;
export const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));
export const round = (v: number, d = 3) => Math.round(v * 10 ** d) / 10 ** d;
export const isImageUrl = (url?: string | null) => !!url && /\.(jpg|jpeg|png|gif|webp)(\?|$)/i.test(url);

export const stickerPx = (box: { w: number; h: number }, scale: number) =>
  Math.min(box.w, box.h) * STICKER_BASE_FRACTION * scale;

/** The rect an image of aspect `ar` occupies inside a `cw`×`ch` box with resizeMode contain. */
export const containRect = (cw: number, ch: number, ar: number) => {
  if (!cw || !ch || !ar) return { left: 0, top: 0, w: cw, h: ch };
  if (cw / ch > ar) {
    const w = ch * ar;
    return { left: (cw - w) / 2, top: 0, w, h: ch };
  }
  const h = cw / ar;
  return { left: 0, top: (ch - h) / 2, w: cw, h };
};

export type StickerDraft = { stickerId: string; x: number; y: number; rotation: number; scale: number };
